import { Component } from '@angular/core';
import { IncomeTypeRequest } from '@app/models/payroll/income-type-request.model';
import { Rl1Box } from '@app/models/payroll/rl1-box.model';
import { T4BoxService } from '@app/modules/payroll/services';
import { Rl1BoxService } from '@app/modules/payroll/services/rl1Box.service';
import { BaseForm } from '@forms/base.form';

@Component({
    selector: 'app-request-income-type',
    templateUrl: './request-income-type.template.html',
    styles: `
        h5 {
            color: var(--grey-900);
        }
    `,
})
export class RequestIncomeTypeForm extends BaseForm {
    incomeTypeRequest!: IncomeTypeRequest;
    rl1BoxOptions: Rl1Box[] = [];

    constructor(
        public rl1BoxService: Rl1BoxService,
        public t4BoxService: T4BoxService
    ) {
        super();
        this.resetData();
    }

    reset(): void {
        // Calling form.resetForm after resetData sets everything to null, which breaks server-side validation.
        this.form.resetForm();
        this.resetData();
    }

    private resetData(): void {
        this.incomeTypeRequest = new IncomeTypeRequest();
        this.incomeTypeRequest.taxable = false;
        this.incomeTypeRequest.pensionable = false;
        this.incomeTypeRequest.insurable = false;
        this.incomeTypeRequest.eptable = false;
        this.incomeTypeRequest.periodic = false;
        this.incomeTypeRequest.bonusTax = false;
        this.incomeTypeRequest.recurrable = false;
        this.incomeTypeRequest.hasHours = false;
        this.incomeTypeRequest.multiplier = 0;
        this.incomeTypeRequest.assessable = false;
        this.incomeTypeRequest.vacationable = false;
        this.incomeTypeRequest.t4Boxes = [];
        this.incomeTypeRequest.rl1Boxes = [];
    }
}
